import React from "react";

// A global off switch the site did not otherwise have.
//
// The motion lab needs to render the same sections with nothing playing, as the
// control you judge the rest against — and threading a `disabled` prop down
// through every section component to get there would leave that plumbing behind
// in the shipping page long after the lab had been deleted. A context costs the
// pages nothing: they never mention it, and the default is on.
const MotionContext = React.createContext({ enabled: true });

export function MotionSettings({ enabled = true, children }) {
  // Memoised on `enabled` alone. A fresh object literal here would be a new
  // context value on every render of whatever wraps this, which every consuming
  // Reveal would see as a change — and the hook's effect depends on it, so each
  // one would tear its observer down and build another.
  const value = React.useMemo(() => ({ enabled }), [enabled]);
  return (
    <MotionContext.Provider value={value}>{children}</MotionContext.Provider>
  );
}

export default MotionContext;
